import _ from 'lodash';

export async function ensureSelectedVesselInList({
  vesselId,
  vesselList,
  existingVessels = [],
  existingFilteredVessels = [],
  loadVesselFn,
  sortFn = (a, b) => a.name.localeCompare(b.name)
}) {
  if (!vesselId) {
    return vesselList;
  }
  
  if (_.find(vesselList, {id: vesselId})) {
    return vesselList;
  }
  
  let selectedVessel = _.find(existingVessels, {id: vesselId}) ||
                       _.find(existingFilteredVessels, {id: vesselId});
  
  if (!selectedVessel && loadVesselFn) {
    selectedVessel = await loadVesselFn(vesselId);
  }
  
  if (selectedVessel) {
    vesselList.push(selectedVessel);
    vesselList.sort(sortFn);
  }
  
  return vesselList;
}

